import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

export const backButtonContainer = css`
  display: inline-block;
`;

export const backButton = css`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const margin = css`
  margin-bottom: 1.5rem;
`;

export const chevron = css`
  font-size: ${typography.captionFontSize};
`;
